@if (company) {
    <div [@FadeInfoBar] class="flex flex-col gap-y-10 sticky top-[450px] p-10 w-[335px] bg-white rounded-lg shadow-md">
    @if (!isFollowedCompany) {
      <expo-button
        [reverseHighlight]="true"
        (click)="toggleFollowedCompany()"
        class="w-full"
      i18n>Follow</expo-button>
    }
    <div class="flex flex-col w-full text-white">
      <div class="flex h-16 items-center place-content-center rounded-t-md bg-green-200" i18n>
      Request Information
    </div>
      <div matRipple class="flex items-center w-full p-2 cursor-pointer bg-green-300 hover:bg-green-800"
        (click)="showTelephonNumber()">
        <div class="flex flex-grow" i18n>Call</div>
        <mat-icon svgIcon="core:phone"></mat-icon>
      </div>
      @if (isShowNumber) {
        <a class="flex items-center w-full p-2 cursor-pointer bg-green-300 hover:bg-green-800" href="tel:{{company.contacts[0].telephone}}">
          <div matRipple class="actionExpander actionExpander1">
            <div>{{company.contacts[0].telephone}}</div>
          </div>
        </a>
      }
      @if (company.accountType === accountType.customer) {
        <div  matRipple
          class="flex items-center w-full p-2 cursor-pointer bg-green-400 hover:bg-green-800"
          (click)="openRequestInfo(requestType.videocall)">
          <div class="flex flex-grow" i18n>Video call</div>
          <mat-icon svgIcon="stand:video_call"></mat-icon>
        </div>
      }
      @if (company.accountType === accountType.customer) {
        <div  matRipple
          class="flex items-center w-full p-2 cursor-pointer bg-green-500 hover:bg-green-800"
          (click)="openRequestInfo(requestType.message)">
          <div class="flex flex-grow" i18n>Message</div>
          <mat-icon svgIcon="stand:message"></mat-icon>
        </div>
      }
      @if (company.accountType === accountType.customer) {
        <div  matRipple
          class="flex items-center w-full p-2 cursor-pointer bg-green-600 hover:bg-green-800"
          (click)="openRequestInfo(requestType.catalog)">
          <div class="flex flex-grow" i18n>Catalog</div>
          <mat-icon svgIcon="stand:note"></mat-icon>
        </div>
      }
      <div (click)="getDirection()" matRipple  class="flex items-center w-full p-2 cursor-pointer bg-green-700 hover:bg-green-800">
        <div class="flex flex-grow" i18n>Directions</div>
        <mat-icon svgIcon="stand:directions"></mat-icon>
      </div>
      <div (click)="openWebsite()" matRipple class="flex items-center w-full p-2 cursor-pointer rounded-b-md bg-green-900 hover:bg-green-800">
        <div class="flex flex-grow" i18n>Website</div>
        <mat-icon svgIcon="stand:language"></mat-icon>
      </div>
    </div>
    @if (isFollowedCompany) {
      <button
        (click)="toggleFollowedCompany()"
        class="w-full !bg-gray-100 !text-gray-400"
      i18n="Follow Company button|click to follow" mat-raised-button >Unfollow</button>
    }
    @if (company.associations[0]) {
      <div class="text-2xl" i18n>
    Member of:
  </div>
    }
    @if (company.associations[0]) {
      <div class="inline-flex flex-wrap gap-3">
        @for (association of company.associations; track association._id) {
          <cld-picture
            [link]="association | getCompanyUrl"
            [image]="association.logo" [title]="association.fullName"
            [sourceMediaSizes]="[{w: 60, h: 60, resizeMode: 'scale'}]">
          </cld-picture>
        }
      </div>
    }
    @if (company.socials[0]) {
      <div class="text-2xl" i18n>
    Company Socials
  </div>
    }
    @if (company.socials[0]) {
      <div class="inline-flex flex-wrap gap-3">
        @for (social of company.socials; track $index) {
          <a rel="nofollow" target="_blank" [href]="social.url">
            <mat-icon class="!w-8 !h-8 text-black" [svgIcon]="'core:' + social.name"></mat-icon>
          </a>
        }
      </div>
    }
  </div>
}
